import { createActions, createReducer } from 'reduxsauce'

import ConsultaRemuneracaoADMRHService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaConcursoSelecoesInicio: [],
    buscaConsultaConcursoSelecoesErro: ['erro'],
    buscaConsultaConcursoSelecoesSucesso: ['consultaConcursoSelecoes'],
    limpar: [],
    setConsultaConcursoSelecoesEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.consultarConcurso = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaConcursoSelecoesInicio())
        let serv = new ConsultaRemuneracaoADMRHService()
        return serv
            .consultarConcurso(filtro)
            .then(response => dispatch(Creators.buscaConsultaConcursoSelecoesSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaConcursoSelecoesErro(error)))
    }
}

const buscaConsultaConcursoSelecoesInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaConcursoSelecoesErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaConcursoSelecoesSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaConcursoSelecoes.resultado,
        dataSincronizacaoDados: action.consultaConcursoSelecoes.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaConcursoSelecoesEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_CONCURSO_SELECOES_INICIO]: buscaConsultaConcursoSelecoesInicio,
    [Types.BUSCA_CONSULTA_CONCURSO_SELECOES_ERRO]: buscaConsultaConcursoSelecoesErro,
    [Types.BUSCA_CONSULTA_CONCURSO_SELECOES_SUCESSO]: buscaConsultaConcursoSelecoesSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_CONCURSO_SELECOES_ESTADO_DT]: setConsultaConcursoSelecoesEstadoDT,
})
